import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import downloadFile, { clearDownloadFile } from '../../thunks/general/downloadFile';
import Text from '../Text/Text';
import { IconLoading } from '../../assets/icon';
import fileIcon from '../../constants/fileIcon';

const DownloadFileModal = ({
 visible, toggleVisible, type, filter
}) => {
  const dispatch = useDispatch();
  const {
    downloadFile: {
      loading, data, data: {
        url, format
      } = {}
    },
  } = useSelector((state) => ({
    downloadFile: state?.downloadFile,
  }), shallowEqual);
  const downloadFileAutomatically = () => window.open(url, '_blank');

  useEffect(() => {
    if (!visible) {
      dispatch(clearDownloadFile());
    }
  }, [visible]);

  const onSave = () => {
    if (url) {
      downloadFileAutomatically();
    } else {
      dispatch(downloadFile({
        type,
        filter
      }));
    }
  };

  const Icon = fileIcon[format] || fileIcon.xlsx;

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="File download"
      subTitle={`type: ${type}`}
      hideCloseBtn
      saveText={`${!url ? 'Generate' : 'Download'}`}
      onSave={onSave}
      canSave={!!data && loading}
    >
      <div>
        {!loading && !data && (
        <Text text={`Generate ${type} file?`} />
        )}
        {loading && (
        <div className="flex justify-center">
          <IconLoading widht={100} height={50} className="spin" />
        </div>
        )}
        {!loading && data && (
        <div className="flex justify-center items-center">
          <a href={url} target="_blank" rel="noreferrer" className="globalLink">
            <div className="flex justify-center">
              <Icon widht={100} height={50} />
            </div>
            <Text
              muted
              text={"Click Here If Your Download Doesn't Start Automatically"}
              textStyle="text-[10px]"
            />
          </a>
        </div>
        )}
      </div>

    </Modal>
  );
};

DownloadFileModal.propTypes = {
  type: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  filter: PropTypes.shape({}),
};

DownloadFileModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  filter: {}
};

export default DownloadFileModal;
